import { ROUTE_PATHS } from '../../modules/route-paths';

const RESERVED = new Set([
  'api',
  'assets',
  'static',
  ...Object.values(ROUTE_PATHS)
    .map((path) => path.split('/')[1])
    .filter((part) => part && !part.startsWith('$')),
]);

const SEGMENT = '[a-z0-9][a-z0-9-]*';
const PRODUCT = new RegExp(`^/(${SEGMENT})/products/${SEGMENT}$`);
const CARD = new RegExp(`^/(${SEGMENT})/cards/${SEGMENT}$`);
const DECK_SALE = new RegExp(`^/decks/ofertas/${SEGMENT}$`);
const EVENT = new RegExp(`^/eventos/${SEGMENT}$`);
const STORE = new RegExp(`^/(?:lojas/)?(${SEGMENT})$`);

export const isPublicMetadataPath = (pathname: string) => {
  const path = pathname.replace(/\/+$/, '');
  const card = path.match(CARD);
  const product = path.match(PRODUCT);
  const store = path.match(STORE);
  return Boolean(
    (card && !RESERVED.has(card[1])) ||
    (product && !RESERVED.has(product[1])) ||
    EVENT.test(path) ||
    DECK_SALE.test(path) ||
    (store &&
      !RESERVED.has(store[1]) &&
      !['api', 'assets', 'static'].includes(store[1])),
  );
};
